import React from 'react';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
    iconWithLabel: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        cursor: 'pointer',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        marginLeft: `${theme.spacing(1)}px !important`,
    },
    disableMargin: {
        margin: 0,
    },
    disableMarginTop: {
        marginTop: 0,
    },
    disableMarginBottom: {
        marginBottom: 0,
    },
    icon: {
        marginLeft: theme.spacing(2),
        cursor: 'pointer',
    },
}));

export const LabelButton = ({
                                title,
                                icon,
                                onClick,
                                disableMargin = false,
                                disableMarginTop = false,
                                disableMarginBottom = false,
                                typographyProps = {},
}) => {
    const classes = useStyles();

    return (<div
        className={clsx(classes.iconWithLabel, {
            [classes.disableMargin]: disableMargin,
            [classes.disableMarginTop]: disableMarginTop,
            [classes.disableMarginBottom]: disableMarginBottom,
        })}
        onClick={onClick}
    >
        <Typography
            noWrap
            {...typographyProps}
        >{title}</Typography>
        <div
            className={classes.icon}
        >{icon}</div>
    </div>)
}
